import React from "react";
import {Popconfirm} from "antd";

export const TestNotificationPopup = ({children, onConfirm}) => {
    return (
        <Popconfirm
            title="Kuryeye test bildirimi gönderilecektir. Emin misiniz?"
            onConfirm={onConfirm}
            okText="Evet"
            cancelText="Hayır"
        >
            {children}
        </Popconfirm>
    );
};
